<template>
<div>
<ContentHeader title="Otomasyon"  url="ProjectConditions" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>
<template v-if="!loading">
<div class="mt-4">


<Dropdown  v-model="projectcondition.event" :options="events" optionLabel="name" optionValue="code" class=" p-inputtext-sm" @change="eventSelected"/>
<br>

<div class="col-12" v-if="projectcondition.conditions.length">
<hr>
<p class="text-primary mb-0">Aşağıdaki koşullar yerine geldiyse</p>
</div>

<ProjectConditionLine v-for="condition in projectcondition.conditions" :customattributes="customattributes" :conditiondata="condition" @conditionConcluded="conditionConcluded" @removeCondition="removeCondition"></ProjectConditionLine>





<template v-if="conditions_done">
<div class="col-12" >
<hr>
<p class="text-primary mb-0">Aşağıdaki eylemleri gerçekleştir</p>
</div>
<Dropdown   v-model="projectcondition.action.name" :options="actions" optionLabel="name" optionValue="code" class=" p-inputtext-sm" @change="actionSelected"/>


<template v-if="projectcondition.action.name=='send_mail'">
  <template v-if="mail_templates.length">
  <Dropdown  v-model="projectcondition.action.mailtemplate_id" :options="mail_templates" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="mailTemplateSelected"/>
  <Button  icon="pi pi-eye"  class=" p-button-primary p-button-outlined  p-button-sm ml-2" @click="showMailTemplateModal"/>
</template>
</template>

<template v-if="projectcondition.action.name=='send_mail_to_contact'">
  <template v-if="mail_templates.length">
  <Dropdown  v-model="projectcondition.action.mailtemplate_id" :options="mail_templates" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="mailTemplateSelected"/>
  <Button  icon="pi pi-eye"  class=" p-button-primary p-button-outlined  p-button-sm ml-2" @click="showMailTemplateModal"/>

  <InputText  type="text" placeholder="email"  v-model="projectcondition.action.mail_recipient" class="ml-2 p-inputtext-sm"  @input="mailRecipientEntered"/>
</template>
</template>


<template v-if="projectcondition.action.name=='attach_to_project'">
<Dropdown  v-model="projectcondition.action.add_to_project_id" :options="brandprojects" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="projectSelected"/>
</template>


<template v-if="projectcondition.action.name=='attach_to_flow'">
<Dropdown  v-model="projectcondition.action.goto_flow_id" :options="projectflows" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="flowSelected"/>
</template>


<template v-if="projectcondition.action.name=='update_custom_attribute'">
<Dropdown  v-model="projectcondition.action.custom_attribute_id" :options="customattributes" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="customAttributeSelected"/>




<template v-if="selected_custom_attribute">  

<span class="ml-2">nitelik değerini, </span>

<InputNumber   placeholder="Sayısal değer" v-if="selected_custom_attribute.type=='number'" v-model="projectcondition.action.custom_attribute_value" class="ml-2 p-inputtext-sm"  @input="customAttributeValueEntered"/>

<InputText  type="text" placeholder="Text değeri" v-if="selected_custom_attribute.type=='string'" v-model="projectcondition.action.custom_attribute_value" class="ml-2 p-inputtext-sm"  @input="customAttributeValueEntered"/>

<Dropdown :filter="true" v-if="selected_custom_attribute.type=='select' " v-model="projectcondition.action.custom_attribute_value" :options="selected_custom_attribute.options" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm"  @change="customAttributeValueEntered"/>

<Dropdown  v-if=" selected_custom_attribute.type=='boolean'" v-model="projectcondition.action.custom_attribute_value" :options="booleanoptions" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm"  @change="customAttributeValueEntered"/>



<span class="ml-2">olarak güncelle </span>


</template>


</template>




</template>



<div class="flex align-items-center justify-content-end mb-6 mt-4" v-if="ready_to_save">

<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary" :loading="$store.state.ui.submitting" type="submit" @click="submit"></Button>
</div>



</div>
</template>



<ProjectMailTemplateModal ref="mailtemplatemodal" :languages="languages" :mailtemplate="selected_mailtemplate" @newMailTemplateSubmitted="newMailTemplateSubmitted"></ProjectMailTemplateModal>
</div>
</template>

<script>
const condition_obj= {
  id:null,
  customattribute_id:null,
  operator:null,//and, or
  numerical_val:null,
  text_val:null,
  execution_type:null,//equal_to,not_equal_to,less_than,greater_than,includes,does_not_include,  
}

const mail_template= {
  id:null,
  name:null,
  brand_id:null,//and, or
  translations:[],
}


import ProjectConditionLine from "./ProjectConditionLine"
import ProjectMailTemplateModal from "./ProjectMailTemplateModal"

export default {

  name: 'ProjectCondition',

  data () {
    return {
      customattributes:[],
      mail_templates:[],
      languages:[],
      brandprojects:[],
      projectflows:[],
      ready_to_save:false,
      loading:true,
      events:[
      {name:"Tedarikçi eklendiğinde",code:"supplier_added"},
      {name:"Tedarikçi çıkartıldığında",code:"supplier_removed"},
      {name:"Tamamlandığında",code:"project_concluded"},
      {name:"Proje bilgisi güncellendiğinde",code:"project_info_updated"},
      ],
      actions:[
      {name:"Tedarikçiye bildirim gönder",code:"send_mail"},
      {name:"Adrese bildirim gönder",code:"send_mail_to_contact"},
      {name:"Projeye ekle",code:"attach_to_project"},
      {name:"Akışa ekle",code:"attach_to_flow"},
      {name:"Özel Niteliği Güncelle",code:"update_custom_attribute"},
      {name:"Proje sürecini tamamla",code:"end_project_process"},
      ],
      projectcondition:{
        event:null,
        action:{
          name:null,
          mailtemplate_id:null,
          mail_recipient:null,
          add_to_project_id:null,
          goto_flow_id:null,
          custom_attribute_id:null,
          custom_attribute_value:null
        },
        conditions:[],
      },
      conditions_done:false,
      selected_mailtemplate:null,
      selected_custom_attribute:null,

    }
  },
  components:{ProjectConditionLine,ProjectMailTemplateModal},
  async mounted()
  {
    if(this.$route.params.condition_id)
    {
        this.loading = await true
        await this.getData()
        await this.getConditionData()
        this.loading = await false
        
    }
    else
    {
        this.loading = await true
        await this.getData()
        this.loading = await false
    }
  	
  },
  methods:{
    eventSelected()
    {
      if(this.projectcondition.conditions.length==0)
      {
        this.addNewCondition()
      }
      
    },
    mailTemplateSelected()
    {
      
      if(this.projectcondition.action.mailtemplate_id===0)
      {
        let selected_mailtemplate =  this.sanitizeArray(mail_template)
        for(let item of this.languages)
        {
          let translation_obj = {
            id:null,
            language_id:item.id,
            mailtemplate_id:null,
            language:item,
            content:null,
            title:null,
          }
          selected_mailtemplate.translations.push(translation_obj)
        }
        this.selected_mailtemplate = selected_mailtemplate
        setTimeout(()=>{
          this.showMailTemplateModal()
        })        
      }
      else
      {
        this.selected_mailtemplate = this.mail_templates.find((item)=>{return item.id == this.projectcondition.action.mailtemplate_id})
        this.ready_to_save = true
      }
    },
    mailRecipientEntered()
    {
      if(this.projectcondition.action.mail_recipient && this.projectcondition.action.mail_recipient.length>5)
      {
        this.projectcondition.action.mail_recipient = this.projectcondition.action.mail_recipient.trim()
        this.ready_to_save = true
      }
      
    },
    async newMailTemplateSubmitted(template)
    {
      
      await this.renewMailTemplates()
      this.projectcondition.action.mailtemplate_id = await template.id
      this.selected_mailtemplate = await template
      this.ready_to_save = await true
    },
    async renewMailTemplates()
    {
      this.mail_templates = await []
      this.mail_templates = await this.generalApiGetWithoutLoader("brand/mailtemplates/"+this.$store.state.projects.project.brand_id) 
      await this.mail_templates.push({name:this.$store.state.languages.lang_phrases.yeni_ekle,id:0})
    },
    showMailTemplateModal()
    {
      this.$refs.mailtemplatemodal.showModal()
    },
    projectSelected()
    {
      this.ready_to_save = true
    },
    flowSelected()
    {
      this.ready_to_save = true
    },
    customAttributeSelected()
    {
      this.selected_custom_attribute = this.customattributes.find((item)=>{return item.id == this.projectcondition.action.custom_attribute_id})
    },
    customAttributeValueEntered()
    {
      this.ready_to_save = true
    },
    async actionSelected()
    {
      console.log(this.projectcondition.action)
      if(this.projectcondition.action.name=="send_mail" || this.projectcondition.action.name=="send_mail_to_contact")
      {
          this.languages = await this.generalApiGetWithoutLoader("project/languages/"+this.$store.state.projects.project.id) 
          await this.renewMailTemplates()
      }

      if(this.projectcondition.action.name=="attach_to_project")
      {
        let brandprojects = await this.generalApiGetWithoutLoader("brand_projects/"+this.$store.state.projects.project.brand_id) 
        this.brandprojects = await brandprojects.filter((item)=>{return item.id !== this.$store.state.projects.project.id})
        
      }

      if(this.projectcondition.action.name=="attach_to_flow")
      {
        this.projectflows = await this.generalApiGetWithoutLoader("project_flows/"+this.$store.state.projects.project.id) 
        
      }

      if(this.projectcondition.action.name=="end_project_process")
      {
        this.ready_to_save = true
      }
      
    },
    async getConditionData()
    {
      let projectcondition = await this.generalApiGetWithoutLoader("project/condition/"+this.$route.params.condition_id)
      await console.log("projectcondition")
      await console.log(projectcondition)
      projectcondition.action = await JSON.parse(projectcondition.action)
      projectcondition.conditions = await JSON.parse(projectcondition.conditions)
      if(projectcondition.action.name=="send_mail" || projectcondition.action.name=="send_mail_to_contact")
      {        
        this.languages = await this.generalApiGetWithoutLoader("project/languages/"+this.$store.state.flows.flow.project_id) 
        await this.renewMailTemplates()
        await console.log(this.mail_templates)
         let the_mail_template = await this.mail_templates.find((item)=>{return item.id == projectcondition.action.mailtemplate_id})
        this.selected_mailtemplate = await the_mail_template
      }
      if(projectcondition.action.name=="attach_to_project")
      {
        let brandprojects = await this.generalApiGetWithoutLoader("brand_projects/"+this.$store.state.projects.project.brand_id) 
        this.brandprojects = await brandprojects.filter((item)=>{return item.id !== this.$store.state.projects.project.project_id}) 
      }
      if(projectcondition.action.name=="attach_to_flow")
      {
        this.projectflows = await this.generalApiGetWithoutLoader("project_flows/"+this.$store.state.projects.project.id)
        console.log("projectflows")
        console.log(this.projectflows)
      }

       if(projectcondition.action.name=="update_custom_attribute")
      {
        this.selected_custom_attribute = await this.customattributes.find((item)=>{return item.id == projectcondition.action.custom_attribute_id})
        
      }

      this.projectcondition = await projectcondition
      this.ready_to_save = await true
      this.conditions_done = await true
    },
  	async getData()
  	{
      
  		console.log(this.$store.state.projects.project)
  		this.customattributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$store.state.projects.project.brand_id)
      await console.log("customattributes")
      await console.log(this.customattributes)
      if(this.$store.state.projects.project.type!=="education")
      {
        //await this.customattributes.push({name:this.$store.state.languages.lang_phrases.puan,id:"points",type:"number"})
      }
       await this.customattributes.unshift({name:"Koşulsuz olarak",id:"no_condition",options:[]})
  		
  		console.log(this.customattributes) 
  	},
    addNewCondition()
    {
      let new_condition =  this.sanitizeArray(condition_obj)
      new_condition.id =  Math.floor(Date.now() / 1000)
      this.projectcondition.conditions.push(new_condition)
    },
    conditionConcluded(data)
    {
      console.log(data)
      let ind = this.projectcondition.conditions.findIndex((item)=>{return item.id == data.id})
      let first = this.projectcondition.conditions[0]
      if(first && first.operator !== data.operator && data.operator !=="execute")
      {
        this.showMessage("error","Koşuldaki her mantık operatörünün aynı olması gerekli",first.operator+" operatörü ile devam edin")
        return false
      }
      this.projectcondition.conditions[ind] = data
      
      if(data.operator !=="execute")
      {

        this.addNewCondition()
      }
      else
      {
       this.conditions_done = true
        
      }
      console.log(this.projectcondition.conditions)
      
    },
    async removeCondition(data)
    {
      await console.log("removeCondition")
      await console.log(data)
      let conditions = await this.projectcondition.conditions.filter((item)=>{return item.id !== data.id})
      await console.log(conditions)
      this.projectcondition.conditions = await []
      //return false
      if(conditions.length)
      {
        this.projectcondition.conditions = await conditions
        //let last = await this.conditions[this.conditions.length-1]
        //last.operator = await "execute"
      }
      else
      {
        await this.addNewCondition()
      }
      await console.log(this.projectcondition.conditions)      
    },
    submit()
    {
      let formdata = new FormData()
      console.log(this.$route.params)
      console.log(this.projectcondition)
      //return false
      formdata.append('projectcondition', JSON.stringify(this.projectcondition));
      if(this.$route.params.condition_id)
      {
          this.generalSubmission(formdata,"projectcondition/update/"+this.$route.params.condition_id,this.afterSubmit)
      }
      else
      {
          this.generalSubmission(formdata,"projectcondition/store/"+this.$route.params.id,this.afterSubmit)
      }
    },
    afterSubmit(response)
    {
      console.log(response.data)
      this.$router.push({ name: 'ProjectConditions'})
    }
  	
  }
}
</script>

<style lang="css" scoped>
</style>